<template>
	<div id="activity5">

		<div class="box">
			<img src="http://static.yuread.cn/quick/72-8.png" alt="" class="h">
			<div class="bb">
				<div class="option" @click="active=112;doRecharge();">
					<p class="title">新年有礼</p>
					<div class="info">
						<h3><span>¥</span>55</h3>
						<p class="a">充值55元得88元</p>
						<p class="b">超值畅读</p>
					</div>
				</div>
				<div class="option" @click="active=113;doRecharge();">
					<p class="title">限时活动</p>
					<div class="info">
						<h3><span>¥</span>88</h3>
						<p class="a">充值88元得128元</p>
						<p class="b">专享特惠</p>
					</div>
				</div>
			</div>

		</div>

		<div class="tip">

			<p>书币属于虚拟商品，一经购买不得退换</p>
			<p>活动最终解释权归网站所有</p>
		</div>
	</div>
</template>

<script>
    export default {
        name: "Activity3",
        data(){
            return {
                active:110,
            }
        },methods:{
            doRecharge(){

                let userInfo = this.$store.getters.getUserInfo;
                if(!userInfo.id){
                    this.$router.push({name:"Login",query:{cburl:this.$route.path}});
                    return ;
                }

                var loading = this.$loading({
                    lock: true,
                    text: '充值订单生成中...',
                });
                //先查询用户是否参与过首充优惠
                this.axios.post('/api/recharge/actives',{
                    type : 30,
                    rid : this.active,
                }).then(r => {
                    loading.close()
                    let data = r.data;
                    if(data.code == 0){
                        alert(data.msg);
                    } else if(data.code == 1){
                        location.href= process.env.VUE_APP_API + '/login/getOpenid/?orders=' + data.data.orders;
                    }
                })
            }
        }
    }
</script>

<style lang="less">
#activity5{min-height:100%;background-color:#ca2523;overflow: auto;background-image: url("http://static.yuread.cn/quick/72-7.png");background-repeat: no-repeat;background-size: 100% auto;
	.a{width: 100%;}
	.box{width: 698px;height:640px;background:#fff;border-radius:12px;margin:660px auto 30px;background-repeat: no-repeat;padding-top: 20px;
		.h{width: 506px;height: 70px;display: block;margin:50px auto;}
		.bb{padding:0px 40px 0;justify-content: space-between;width: 100%;display: flex;}
		.option{width: 300px;height:342px;background-image: url("http://static.yuread.cn/quick/71-3.png");background-size:100% 100%;background-repeat:no-repeat;
			.title{text-align: center;font-size: 24px;color: #B2000D;line-height: 46px;}
			.info{text-align: center;
				h3{font-size: 72px;color: #FD1B1F;
					span{font-size: 40px;}
				}
				.a{font-size: 20px;color: #B48037;margin: 10px 0;}
				.b{font-size: 24px;color: #D55111;margin: 10px 0;}
			}
		}
	}
	.box1{width: 668px;height: 556px;margin: 30px auto 80px;
		img{width: 100%;height: 100%;}
	}
	.tip{font-size: 24px;color: #fff;text-align: center;margin-top: 20px;}
	.type{
		background-color: rgba(0,0,0,.3);position: fixed;top:0;left:0;right:0;bottom:0;
		ul{ position:absolute;bottom:0;width: 100%;background-color: #fff;display: flex;justify-content: space-between;padding: 102px 40px 68px;border-radius: 58px 58px 0 0;
			li{width: 308px;height:86px;text-align: center;border-radius: 43px;color: #fff;font-size: 32px;line-height: 86px;}
			.wechat{background-color: #32BE1B;}
			.zfb{background-color: #1296db;}
			img{width: 34px;height:34px;position: relative;top:5px;}
		}
	}
}


</style>
